// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "form".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { formKindValues } from '@borradh-workspace/labels';
/** Response atom for the "form" table (1:1 with a DB row, on the wire). */
export const formAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    kind: z.enum(formKindValues),
    name: z.string(),
    description: z.string().nullable(),
    fields: z.unknown(),
    requiresSignature: z.boolean(),
    patientVisibility: z.enum(['staff_only', 'patient']),
    isActive: z.boolean(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=form.js.map